var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2722_11530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 0.000976562C3.58881 0.000976562 0 3.5897 0 8.00093C0 12.4122 3.58881 16.001 7.99996 16.001C12.4111 16.001 15.9999 12.4122 15.9999 8.00093C15.9999 3.5897 12.4112 0.000976562 7.99996 0.000976562ZM12.5937 6.64967L7.56771 11.6756C7.354 11.8893 7.06993 12.007 6.76774 12.007C6.46555 12.007 6.18147 11.8893 5.96777 11.6756L3.40624 9.11412C3.19254 8.90041 3.07483 8.61633 3.07483 8.31415C3.07483 8.01187 3.19254 7.72779 3.40624 7.51409C3.61986 7.30039 3.90394 7.18268 4.20621 7.18268C4.5084 7.18268 4.79256 7.30039 5.00618 7.51417L6.76765 9.27556L10.9936 5.04965C11.2073 4.83595 11.4913 4.71832 11.7935 4.71832C12.0957 4.71832 12.3798 4.83595 12.5935 5.04965C13.0348 5.49091 13.0348 6.20858 12.5937 6.64967Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2722_11530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9f7e2d747ccd8f8d57b4ecefb37e8e90.svg";
export { ForwardRef as ReactComponent };